import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SdfCardLabels } from '../../../app.models';
import { MgLocation } from 'src/app/models/location.model';
import { LocationFinderService } from 'src/app/services/location-finder.service';
import { MapService } from 'src/app/services/map.service';
import { BaseComponent } from 'src/app/shared/base.component';
import { MgoDateAdapter } from 'src/app/shared/utils/mg-date-adapter';
import { StringUtils } from 'src/app/shared/utils/string-utils';

@Component({
    selector: 'app-location-search-detail',
    templateUrl: './location-search-detail.component.html',
    styleUrls: ['./location-search-detail.component.scss'],
    standalone: false
})
export class LocationSearchDetailComponent
  extends BaseComponent
  implements AfterViewInit
{
  @Input() public pinSelectedLocation!: boolean;
  @Input() flow: string;
  @Output() back: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() showChangeLocator: boolean = true;
  sdfCardLabels: SdfCardLabels;

  public _labels: any;
  @Input() public set labels(labels: any) {
    this._labels = labels;
    this.sdfCardLabels = labels.stellar.sdfcard;
  }
  public get labels() {
    return this._labels;
  }

  public google: any;

  constructor(
    public locationFinderService: LocationFinderService,
    private mapService: MapService
  ) {
    super();
    this.google = window['google'];
  }

  /**
   * Method - Life cycle hook - after view init
   */
  ngAfterViewInit() {
    /* scroll to top of details on page visible*/
    if (this.locationFinderService.isShowDetail) {
      this.scrollToHeader();
    }
  }

  /**
   * Method - Scroll to top of screen after the view is init
   */
  scrollToHeader() {
    window.scroll(0, 0);
  }

  public goToLocatorPage(): void {
    this.back.emit(true);
  }
}
